import { render, staticRenderFns } from "./innumber.vue?vue&type=template&id=ba5799b6&scoped=true"
import script from "./innumber.vue?vue&type=script&lang=js"
export * from "./innumber.vue?vue&type=script&lang=js"
import style0 from "./innumber.vue?vue&type=style&index=0&id=ba5799b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5799b6",
  null
  
)

export default component.exports